export default __webpack_public_path__ + "static/media/vector_r.b3890006.png";